<!--
 * @Author: tkp
 * @Date: 2025-07-18 15:25:13
-->
<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { generatePresignedUrl } from '@/utils/api'
export default {
  name: 'App',
  mounted() {
    this.loadCustomFont()
  },
  methods: {
    async loadCustomFont() {
      try {
        const res = await generatePresignedUrl({ fileUrl: '/fileoss/smj_website/fonts/AlimamaFangYuanTiVF-Thin.woff2' })
        if (res && res.data) {
          // fetch 字体文件，转成本地 Blob URL
          const fontResponse = await fetch(res.data)
          const blob = await fontResponse.blob()
          const objectUrl = URL.createObjectURL(blob)

          const style = document.createElement('style')
          style.textContent = `
            @font-face {
              font-family: 'MyCus-Bold';
              src: url('${objectUrl}') format('woff2');
              font-weight: 100 900;
            }
          `
          document.head.appendChild(style)
          // 3. 强制让浏览器重新应用这个字体
          document.body.style.display = 'none'
          document.body.offsetHeight // 触发 reflow
          document.body.style.display = ''
        }
      } catch (e) {
        console.error('字体加载失败:', e)
      }
    }
  }
}
</script>
<style lang="scss">
html,
body,
#app {
  margin: 0;
  width: 100%;
  height: 100%;
}

.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue